import { render, staticRenderFns } from "./ReportPagination.vue?vue&type=template&id=19e3c2a9"
import script from "./ReportPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportPagination.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports